import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import UnknownDumbo from '../../../../Dumbo/Unknown';
import DeviationDumbView from '../../../../Dumbo/EditorDumbo';
import type { LayoutStyleProperties } from '../../../../../types';

import s from './Minimal.scss';

export interface Props {
  deviation?: PapiDeviation;
  width: number;
  height: number;
  className?: string;
  /** used in grids for dynamic positioning to not wrap every item in a container
   * do not abuse for anything else or you will get fire ants in your socks
   */
  style?: LayoutStyleProperties;
  onClick?: () => void;
}

const Minimal: React.FC<Props> = ({
  deviation,
  onClick,
  width,
  height,
  className,
  style,
}) => (
  <Flex
    className={classnames(s['root'], onClick && s['clickable-root'], className)}
    alignItems="center"
    justifyContent="center"
    style={{ width, height, ...style }}
    onClick={onClick}
  >
    {deviation && (
      <DeviationDumbView
        className={s['dumbo']}
        deviation={deviation}
        width={width}
        height={height}
      />
    )}
    {!deviation && (
      <UnknownDumbo className={s['dumbo']} width={width} height={height} />
    )}
    <PromoBadge badgeType="tier" size={24} className={s['badge']} />
  </Flex>
);
Minimal.displayName = 'Minimal';

export default Minimal;
